module.exports = __webpack_public_path__ + "static/media/planificari-icon.f7345270.svg";